module.exports = __webpack_public_path__ + "static/media/slider-project-1.dd08d134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/images/slider-project-1.png
// module id = 370
// module chunks = 0